import * as React from 'react';

var _React$createContext = React.createContext({
  showActionSheetWithOptions: function showActionSheetWithOptions(options, callback) {}
}),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;

export { Provider, Consumer };